/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AdminContext } from "../../context/adminContext";
import Loader from "../../UI/Loader/Loader";
import CoveredBackground from "../../UI/СoveredBackground/СoveredBackground";

import ButtonBack from "../../UI/ButtonBack/ButtonBack";

const MasPage = () => {

  const { getMas, findMas } = useContext(AdminContext);
  const [mas, setMas] = useState([])
  const [loading, setLoading] = useState(true);
  
  const [search, setSearch] = useState("");



  const searchInput = (e) => {
    setSearch(e.target.value);
    if (e.target.value.length === 0) {

      getMas().then(res => {
        if(res.status === 200)
        {
          setMas(res.data)
         
        } else  {
          
        }
      }).finally(() => {
        setLoading(false)
      });

    }



    


  };



  const submithandler = (e) => {
    e.preventDefault();
    if(search.length > 2) {
      findMas(search).then((res) => {
        setLoading(true)
        setMas(res.data)
       
     }).finally(() => {
      setLoading(false)
     });
    }
   
  }; 


 
  useEffect(() => {
    document.title = "МАС'ы "
    getMas().then(res => {
      if(res.status === 200)
      {
        setMas(res.data)
       
      } else  {
        
      }
    }).finally(() => {
      setLoading(false)
    });
  }, []);
  return (
    <div className="container">
     <div className="admin__user__results">
     <ButtonBack/>
      <Link to="/admin/mas/add" className="admin__results__link">Добавить МАС'a</Link>
     
      <div className="admin__user__title">МАС'ы</div>
        <div>
                <input
                  type="text"
                  className="input__search"
                  placeholder="Поиск по фамилии"
                  value={search}
                  onInput={searchInput}
                />
                <button
                  className="search__btn"
                  style={{ marginLeft: 15 }}
                  disabled={search.length <= 2 && "disabled"}
                  onClick={submithandler}
                >
                  Найти
                </button>
              </div>
        <div className="admin__user__items">
            {
              loading ? (<CoveredBackground>
                <Loader />
              </CoveredBackground>) :
              (
                mas.map((m) => (
                  m.active ? <div className="admin__user__item" key={m.id}>
                  <Link to={"/admin/mas/" + m.id} className="admin__menu__item">
                    {m.surname} {m.name[0]}. 
                  </Link>
                </div> 
                :
                <div className="admin__user__item" style={{backgroundColor: '#cccccc'}} key={m.id}>
                    <Link to={"/admin/mas/" + m.id} className="admin__menu__item">
                      {m.surname} {m.name[0]}.
                    </Link>
                  </div>
                ))
               
              )
            }
            
        </div>

        {mas.length == 0 && <p style={{textAlign: 'center', color: '#ca2a2a', fontSize: '25px'}}> Ничего не найдено </p>}
     </div>
    </div>
  );
};

export default MasPage;
